import React, { useContext } from 'react';
import { Context } from '../context/AppContext';

const Image = ({ src, alt, fallback, ...props }) => {
  const { webp } = useContext(Context);
  return <img src={webp ? src : fallback} alt="" {...props} />;
};

export default Image;
